// extracted by mini-css-extract-plugin
module.exports = {"grid":"archiveGrid_grid__Mv4zv","innerGrid":"archiveGrid_innerGrid__b8uZU"};